import { path } from 'ramda';
import { useSelector } from 'react-redux';

const useUserLanguage = () => useSelector((state) => path(['user', 'language'], state));

export default useUserLanguage;
